var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { SharedService } from '../../services/shared.service';
var Signer = (function () {
    function Signer(id, doc) {
        this.id = id;
        this.doc = doc;
        this._jnlp = new JnlpLauncher();
        this._status = CLOSED;
        this.aliases = [];
        this.commonNames = [];
        this.onInit = new EventEmitter(false);
        this.onReady = new EventEmitter(false);
        this.onAliasOk = new EventEmitter(false);
        this.onSignOk = new EventEmitter(false);
        this.onError = new EventEmitter(false);
        this.onClose = new EventEmitter(false);
        this.onStatusChange = new EventEmitter(false);
        var that = this;
        this._ws = new WebsocketClient(SharedService.getProp("services_url").replace("/api/", "/").replace("http", "ws") + "backend-websocket", id, doc);
        this._ws.onready.subscribe(function (event) { that.loading(event); });
        this._ws.onmessage.subscribe(function (event) { that.processMessage(event); });
        this._ws.onclose.subscribe(function (event) { that.close(event); });
        this._ws.onerror.subscribe(function (event) { that.error(event); });
        if (!SharedService.getProp("firma_simulada")) {
            this._ws.connect(); // conectar websocket e inicializar canal de com.
        }
        else {
            //console.log("-- Firma SIMULADA -- ...");
            setTimeout(function () {
                that.changeStatus(READY);
                that.aliases = ["alias1 (FIRMA)", "alias2 (AUTENTICACION)", "alias3"];
                that.commonNames = ["alias1 (FIRMA)", "alias2 (AUTENTICACION)", "alias3"];
                that.changeStatus(ALIASOK);
            }, 3000);
        }
    }
    Signer.prototype.getStatus = function () {
        return this._status;
    };
    Signer.prototype.changeStatus = function (status) {
        this._status = status;
        switch (this._status.code) {
            case LOADING.code:
                this.onStatusChange.emit(LOADING);
                break;
            case READY.code:
                this.onReady.emit(READY.code);
                break;
            case ALIASING.code:
                this.onStatusChange.emit(ALIASING);
                break;
            case ALIASOK.code:
                this.onAliasOk.emit(ALIASOK.code);
                break;
            case SIGNING.code:
                this.onStatusChange.emit(SIGNING);
                break;
            case SIGNOK.code:
                this.onSignOk.emit(SIGNOK.code);
                break;
            case ERROR.code:
                this.onError.emit(ERROR.code);
                break;
            case CLOSING.code:
                this.onStatusChange.emit(CLOSING);
                break;
            case CLOSED.code:
                this.onClose.emit(CLOSED.code);
                break;
            case CANCELED.code:
                this.onClose.emit(CANCELED.code);
                break;
        }
    };
    Signer.prototype.loading = function (uuid) {
        this._uuid = uuid;
        this._jnlp.startApp(this._uuid);
    };
    Signer.prototype.ready = function () {
        this.changeStatus(READY);
        // jnlp cargado, get aliases
        this._ws.doSend('getAliases("","")'); // traer alias de los certificados
    };
    Signer.prototype.processMessage = function (message) {
        var _this = this;
        var pos = message.indexOf("(");
        var method = message.substring(0, pos);
        if (method.endsWith("Error")) {
            var error = message.substring(pos + 2, message.length - 2);
            var result = ERROR.clone();
            result.message = error;
            this.changeStatus(result);
            return;
        }
        else if (method.endsWith("Warning")) {
            var warn = message.substring(pos + 2, message.length - 2);
            //console.log("WARNING: " + warn);
            return;
        }
        else if (method.endsWith("Cancel")) {
            var warn = message.substring(pos + 2, message.length - 2);
            var result = CANCELED.clone();
            result.message = warn;
            this.changeStatus(result);
            return;
        }
        else if (method.endsWith("Ok")) {
            var msg = message.substring(pos + 2, message.length - 2);
            // console.log("OK: " + message);
        }
        switch (method) {
            case "postInitOk":
                this.ready();
                break;
            case "getAliasesOk":
                //console.log("aliases: " + message);
                this.aliases = message.substring(pos + 2, message.length - 2).split(",");
                this._aliasesFlag = this.aliases.length;
                this.aliases.forEach(function (item) {
                    //console.log("getting info for '"+item+"'");
                    //this._ws.doSend('getCertificateInfo(' + item + ')');
                    _this._ws.doSend('getCertificateInfo(' + _this.encodeSpecialChars(item) + ')');
                });
                break;
            case "getCertificateInfoOk":
                // subjectDN, issuerDN, algId, serialNum, extensions, 
                // type, signature, publicKey, [Fecha nac]
                //console.log("aliasgetCertificateInfoOk: " + message);
                message = this.decodeCertificate(message);
                //console.log("message: " + message);
                var commonName = message.substring(11, message.indexOf('issuerDN'));
                //console.log("commonname " + commonName);
                commonName = commonName.substring(commonName.indexOf('CN=') + 3);
                commonName = commonName.substring(0, commonName.indexOf(','));
                if (commonName.startsWith('\\"')) {
                    //console.log('CN: ' + commonName);
                    commonName = commonName.substring(2, commonName.length - 2);
                }
                var certValorT = "";
                certValorT = message.substring(11, message.indexOf('issuerDN'));
                if (certValorT.indexOf(' T=') !== -1) {
                    //console.log("certValorT " + certValorT);
                    certValorT = certValorT.substring(certValorT.indexOf(' T=') + 3);
                    certValorT = certValorT.substring(0, certValorT.indexOf(','));
                    commonName += " - " + certValorT;
                }
                this.commonNames.push(commonName);
                this.updateAliasesFlag();
                break;
            case "signOk":
            case "signLocalOk":
            case "signRemoteOk":
                this.changeStatus(SIGNOK);
                this.close();
                break;
            default: //NOOP
        }
    };
    Signer.prototype.encodeSpecialChars = function (str) {
        return encodeURIComponent(str);
    };
    Signer.prototype.decodeCertificate = function (originalString) {
        // Paso 1: Obtener el substring entre "subjectDN: " y ",issuerDN:"
        var startIndex = originalString.indexOf("subjectDN: ") + "subjectDN: ".length;
        var endIndex = originalString.indexOf(", issuerDN:");
        var subjectDNEncoded = originalString.substring(startIndex, endIndex);
        // Paso 2: Decodificar el valor
        var aux = subjectDNEncoded.replace(/\+/g, " ");
        var decodedSubjectDN = decodeURIComponent(aux);
        // Paso 3: Reemplazar el substring en la cadena original
        var updatedString = originalString.replace(subjectDNEncoded, decodedSubjectDN);
        return updatedString;
    };
    Signer.prototype.updateAliasesFlag = function () {
        this._aliasesFlag = this._aliasesFlag - 1;
        if (this._aliasesFlag == 0) {
            this.changeStatus(ALIASOK);
        }
    };
    Signer.prototype.getAlias = function () {
        if (!SharedService.getProp("firma_simulada")) {
            // NOOP
        }
        else {
            setTimeout(function () {
                this.ready();
                return ["Common Name 1", "Common Name 2", "Common Name 3"];
            }, 1000);
        }
    };
    Signer.prototype.doSign = function (alias) {
        if (!SharedService.getProp("firma_simulada")) {
            // preparando firmado ...
            // TODO SharedService.config.ración de firma local, ver firma remota cuando se implemente en servidor Java
            var service = ""; // no hace falta para firma local
            var tsa = ""; // sin TSA
            //signRemote(String uuid, String url, String alias, String paramExtras)
            this._ws.doSend('signRemote(' + this._uuid + ', ' + SharedService.getProp("services_url") + 'dsign/, ' + this.encodeSpecialChars(alias) + ', "")');
            // this.ws.doSend('signLocal(' + this.selectedAlias + ', CMS_DETACHED, ' + service + ', ' + tsa + ', ' + false + ')');
        }
        else {
            //console.log("simulando firmado ...");
            var that = this;
            setTimeout(function () {
                that.changeStatus(SIGNOK);
            }, 3000);
        }
    };
    Signer.prototype.close = function (event) {
        if (event === void 0) { event = null; }
        if (this._status.code != CLOSED.code) {
            this._status = CLOSING;
            this.finalize();
        }
    };
    Signer.prototype.error = function (error) {
        //console.log(JSON.stringify(error));
        this.changeStatus(ERROR);
    };
    Signer.prototype.finalize = function () {
        if (this._ws) {
            this._ws.close();
            this._ws = null;
        }
        this._jnlp = null;
        this._uuid = null;
        this.changeStatus(CLOSED);
    };
    Signer.prototype.ngOnDestroy = function () {
        this.finalize();
    };
    return Signer;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onInit", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onReady", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onAliasOk", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onSignOk", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onError", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onClose", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], Signer.prototype, "onStatusChange", void 0);
Signer = __decorate([
    Component({
        template: ''
    }),
    __param(0, Inject("id")), __param(1, Inject("doc")),
    __metadata("design:paramtypes", [String, String])
], Signer);
export { Signer };
var JnlpLauncher = (function () {
    function JnlpLauncher() {
        this.targetUrl = "";
        this.extId = "bifafooonggjodidncajenonmobhedoi";
        this.connected = false;
    }
    JnlpLauncher.prototype.startApp = function (uuid) {
        //const cookie = this.getCookie("AWSALB"); 
        //const cookie = this.getCookie("JSESSIONID"); 
        var cookie = this.getCookie("FIRMADORID");
        var jnlpUrl = SharedService.getProp("services_url").replace("/api/", "/") + "api/dsign/jnlp?p=" + uuid + "&FIRMADORID=" + btoa(SharedService.unescape(encodeURIComponent(cookie)));
        //console.log("jnlp " + jnlpUrl);
        if (this.get_browser_info().name.toLowerCase() === "firefox") {
            this.ffoxStartConnection(jnlpUrl);
        }
        else {
            this.chromeStartConnection(jnlpUrl);
        }
    };
    JnlpLauncher.prototype.getCookie = function (name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    };
    JnlpLauncher.prototype.ffoxStartConnection = function (url) {
        if (document.getElementById("ffox-addon-div-sl")) {
            //console.log("using ffox ext ...");
            this.targetUrl = url;
            // HACK una forma de que la function ffoxConnectionOk sea visible 
            // para el content script de la ext de ffox
            window.ffoxConnectionOk = function () {
                var msg = { com: "write", msg: { text: url } };
                window.postMessage(msg, "*");
            };
            window.postMessage({ com: "connect", data: "com.unitech.utils.native.iurix.ffox" }, "*");
        }
        else {
            this.notInstalledFfoxExt();
        }
    };
    JnlpLauncher.prototype.notInstalledFfoxExt = function () {
        alert("No se detectó la presencia de la Extensión de Unitech para Firmas digitales en Firefox"
            + ", a continuación será redirigido al sitio de descarga");
        document.location.href = "https://addons.mozilla.org/en-US/firefox/addon/utilidades-iurix-san-luis/";
    };
    JnlpLauncher.prototype.ffoxConnectionOk = function () {
        this.connected = true;
        this.writeToFfoxExtension(this.targetUrl);
    };
    JnlpLauncher.prototype.writeToFfoxExtension = function (url) {
        //console.log("writeToExtension: " + url);
        var msg = { com: "write", msg: { text: url } };
        window.postMessage(msg, "*");
    };
    JnlpLauncher.prototype.chromeStartConnection = function (url) {
        // llamado directo a background@ext
        this.targetUrl = url;
        var that = this;
        try {
            chrome.runtime.sendMessage(this.extId, {
                com: "connect",
                data: "com.unitech.utils.native.iurix"
            }, function (response) {
                if (!chrome.runtime.lastError) {
                    that.connected = (response.res === "ok");
                    if (that.connected) {
                        that.writeToChromeExtension(url);
                    }
                }
                else {
                    that.notInstalledExt();
                }
            });
        }
        catch (err) {
            //console.log(err);
            that.notInstalledExt();
        }
    };
    JnlpLauncher.prototype.writeToChromeExtension = function (url) {
        try {
            var msg = {
                com: "write",
                msg: {
                    text: url
                }
            };
            chrome.runtime.sendMessage(this.extId, msg, function (response) {
                // NOOP
            });
        }
        catch (e) {
            //console.log("ERROR: " + e);
        }
    };
    JnlpLauncher.prototype.notInstalledExt = function () {
        // this.notInstalled();
        window.open(this.targetUrl, '_blank');
    };
    JnlpLauncher.prototype.notInstalled = function () {
        // var baseUri = "https://nuevo.giajsanluis.gov.ar/";
        // //var baseUri = "http://192.168.40.38:8081/"
        // var context = "iurix-services";
        // console.log("not installed");
        // alert("Se iniciará la descarga de un archivo JNLP para Java Web Start, \n"
        // + "al ejecutar dicha aplicación se instalarán en su disco duro \n"
        // + "los archivos necesarios para utilizar las extensiones del browser.");
        // var code = "com.unitech.app.ExtInstaller";
        // var extType = "x0";
        // var ext_installer = "apps/jar-ext-installer-1.2.11-jar-with-dependencies.jar";
        // var params = "code=" + code + "&MAYSCRIPT=true&codebase_lookup=false"
        // + "&archive=" + ext_installer + "&java_arguments=-Djnlp.packEnabled=true&installext=" + extType
        // + "&codebase=" + encodeURI(baseUri + context);
        // console.log("PARAMS " + params);
        // //document.location = baseUri + context + "/ext?p=" + btoa(params);
        // var target = baseUri + context + "/ext?p=" + btoa(params);
        // window.open(
        //     target,
        //     '_blank'
        // );
    };
    JnlpLauncher.prototype.get_browser_info = function () {
        var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return {
                name: 'IE',
                version: (tem[1] || '')
            };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {
                return {
                    name: 'Opera',
                    version: tem[1]
                };
            }
            tem = ua.match(/Edge\/(\d+)/);
            if (tem != null) {
                return {
                    name: 'Edge',
                    version: tem[1]
                };
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1]
        };
    };
    return JnlpLauncher;
}());
var WebsocketClient = (function () {
    function WebsocketClient(url, id, doc) {
        //Set up the default 'noop' event handlers
        this.onready = new EventEmitter(false);
        this.onclose = new EventEmitter(false);
        this.onmessage = new EventEmitter(false);
        this.onerror = new EventEmitter(false);
        this.url = url;
        this._pid = id;
        this._doc = doc;
    }
    WebsocketClient.prototype.connect = function () {
        this.ready = false;
        this.websocket = new WebSocket(this.url); // crear websocket
        var that = this;
        this.websocket.onopen = function (evt) {
            that.onOpen(evt);
        };
        this.websocket.onmessage = function (evt) {
            that.onMessage(evt);
        };
        this.websocket.onerror = function (evt) {
            that.onError(evt);
        };
        this.websocket.onclose = function (evt) {
            that.ready = false;
        };
    };
    WebsocketClient.prototype.close = function () {
        if (this.ready) {
            this.ready = false;
            var closeMessage = {
                "command": "close",
                "source": "webapp",
                "uuid": "'" + this._uuid + "'",
                "data": ""
            };
            if (this.websocket) {
                this.websocket.send(JSON.stringify(closeMessage));
            }
            this.onclose.emit(closeMessage);
        }
    };
    WebsocketClient.prototype.onOpen = function (evt) {
        this.ready = true;
        // CODE/LIB seteado en backend (es el que debería saber los datos del signer)
        var params = "pid=" + this._pid + "&doc=" + this._doc +
            "&batch=5&codebase=" + encodeURI(SharedService.getProp("services_url").replace("/api/", "/")) + "&title=" + encodeURI("Firma Digital");
        if (window.navigator.platform.toLowerCase().indexOf("win") > -1) {
            params = params + "&os=win";
        }
        else if (window.navigator.platform.toLowerCase().startsWith("mac") ||
            window.navigator.platform.toLowerCase().startsWith("pike")) {
            params = params + "&os=osx";
        }
        else {
            params = params + "&os=linux";
        }
        this.websocket.send('{"command":"init", "source": "webapp", "data": "' + btoa(SharedService.unescape(encodeURIComponent(params))) + '"}');
    };
    WebsocketClient.prototype.onMessage = function (evt) {
        //console.log("RECEIVED: " + evt.data);
        var message = JSON.parse(evt.data);
        switch (message.command) {
            case "init":
                this._uuid = message.data;
                this.ready = true;
                this.onready.emit(this._uuid); // conectado y listo para continuar
                break;
            case "execute":
                //redirect to js  method ok/error/warning
                this.onmessage.emit(atob(message.data)); // "burbujear" mensajes recibidos
                break;
            case "close":
                break;
            default: //noop
        }
    };
    WebsocketClient.prototype.onError = function (evt) {
        console.error("ERROR: " + JSON.stringify(evt));
        this.onerror.emit(evt); // lanzar evento de cierre recibido
    };
    WebsocketClient.prototype.doSend = function (data) {
        if (!this.ready) {
            this.connect();
        }
        this.websocket.send(JSON.stringify({
            "uuid": this._uuid,
            "data": btoa(SharedService.unescape(encodeURIComponent(data))),
            "source": "webapp",
            "command": "execute"
        }));
    };
    return WebsocketClient;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], WebsocketClient.prototype, "onready", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], WebsocketClient.prototype, "onclose", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], WebsocketClient.prototype, "onmessage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], WebsocketClient.prototype, "onerror", void 0);
var Status = (function () {
    function Status(code, message) {
        this.code = code;
        this.message = message;
    }
    Status.prototype.clone = function () {
        return new Status(this.code, this.message);
    };
    return Status;
}());
export { Status };
var LOADING = new Status(0, "LOADING");
var READY = new Status(10, "READY");
var ALIASING = new Status(20, "ALIASING");
var ALIASOK = new Status(30, "ALIASOK");
var SIGNING = new Status(40, "SIGNING");
var SIGNOK = new Status(50, "SIGNOK");
var ERROR = new Status(60, "ERROR");
var CLOSING = new Status(70, "CLOSING");
var CLOSED = new Status(80, "CLOSED");
var CANCELED = new Status(80, "CANCELED");
export var SIGNER_STATUS = {
    "LOADING": LOADING,
    "READY": READY,
    "ALIASING": ALIASING,
    "ALIASOK": ALIASOK,
    "SIGNING": SIGNING,
    "SIGNOK": SIGNOK,
    "ERROR": ERROR,
    "CLOSING": CLOSING,
    "CLOSED": CLOSED,
    "CANCELED": CANCELED
};
//# sourceMappingURL=firma-helper.component.js.map